<template>
  <div id="main">
    <div class="container">
      <div class="title">同业免费注册</div>
      <div class="desc">请填写以下信息，我们将在收到信息后尽快审核。</div>

      <el-form :model="dataModel" ref="dataForm" :rules="rules"
        class="no-required" label-position="top">
        <el-form-item label="旅行社/门店名称" prop="peer_name">
          <el-input type="text" v-model.trim="dataModel.peer_name"
           placeholder="请填写旅行社/门店名称" :maxlength="35"></el-input>
        </el-form-item>

        <el-form-item label="申请人姓名" prop="contacts">
          <el-input type="text" v-model.trim="dataModel.contacts"
            placeholder="请填写申请人姓名" :maxlength="20"></el-input>
        </el-form-item>

        <el-form-item label="联系手机号" prop="mobile_phone">
          <el-input type="text" v-model.trim="dataModel.mobile_phone"
          placeholder="请填写联系手机号" :maxlength="11"></el-input>
        </el-form-item>

        <el-form-item label="邮箱" prop="email">
          <el-input type="text" v-model.trim="dataModel.email"
          placeholder="请填写邮箱" :maxlength="50"></el-input>
        </el-form-item>

        <el-form-item label="企业地址" class="is-required pcds">
          <el-select v-model="dataModel.province_code" placeholder="省" @change="dataModel.city_code=''">
            <el-option :label="v" :value="k" v-for="(v,k) in pcds[86]" :key="k"></el-option>
          </el-select>

          <el-select v-model="dataModel.city_code" placeholder="市" @change="dataModel.county_code=''">
            <el-option :label="v" :value="k" v-for="(v,k) in pcds[dataModel.province_code]" :key="k"></el-option>
          </el-select>

          <el-select v-model="dataModel.county_code" placeholder="区">
            <el-option :label="v" :value="k" v-for="(v,k) in pcds[dataModel.city_code]" :key="k"></el-option>
          </el-select>

          <div class="el-form-item__error" v-if="!pcdValid && submitted"
            style="display:inline-block;margin-left:15px;position:relative;">请选择省市区</div>
        </el-form-item>

        <el-form-item prop="detail_address" style="margin-top:-22px">
          <el-input type="text" v-model.trim="dataModel.detail_address" placeholder="详细地址"></el-input>
        </el-form-item>

        <el-form-item label="来源" class="is-required" prop="peer_from">
          <el-radio class="radio" v-model="dataModel.peer_from" label="1">同行介绍</el-radio>
          <el-radio class="radio" v-model="dataModel.peer_from" label="2">杂志广告</el-radio>
          <el-radio class="radio" v-model="dataModel.peer_from" label="3">旅游展或推介会</el-radio>
          <el-radio class="radio" v-model="dataModel.peer_from" label="4">其他渠道</el-radio>
        </el-form-item>

        <el-form-item label="名片上传" class="is-required">
          <div class="el-upload">
            <div class="el-upload__inner el-dragger" @click="fileInput">
              <img src="../assets/imgs/camera.png" alt="" width="50" class="upload-icon">
              <div class="el-dragger__cover upload-img" v-if="upload_file">
                <el-button type="primary" class="upload-reupload">重新上传</el-button>
              </div>
              <input type="file" accept="image/png, image/jpeg" class="faraway" id="upload-file" @change="fileChange">
            </div>
            <div class="el-upload__tip">*仅支持格式为jpg或png且不超过5M的图片</div>
          </div>

          <transition name="scaleY">
            <div class="el-form-item__error" v-if="!upload_file && submitted">请上传名片</div>
          </transition>
        </el-form-item>

        <div class="common-visa-country">
          <div class="title">常办签国家</div>
          <div v-click-outside="isShowCountryListBox">
            <div class="select-box" @click="isShowCountryListBox(true)">
              <div class="input-box">
                <input type="text" placeholder="最多可选择3个常办签国家" readonly="readonly">
              </div>
              <img src="../assets/imgs/icon-arrow.png" class="icon-arrow" :class="{'rotate': showCountryListBox}">
              <div class="tag-box" v-if="selectedCountry && selectedCountry.length > 0">
                <span v-for="(v, k) in selectedCountry" :key="k">{{v.name}}<img src="../assets/imgs/icon-delete.png" @click="deleteCountry($event, k)"></span>
              </div>

            </div>
            <div class="country-list-box" v-show="showCountryListBox">
              <span v-for="(v, k) in commonVisaCountry" :key="k" :class="{'selected': selectedCountryKey.indexOf(k) > -1}" @click="selectCountry(k)">{{v}}</span>
            </div>
          </div>
        </div>

        <el-form-item label="月办签量" class="month-visa-level">
          <el-select v-model="dataModel.month_visa_level" placeholder="请选择数量">
            <el-option :label="v" :value="k" v-for="(v,k) in monthVisaLevel" :key="k"></el-option>
          </el-select>
        </el-form-item>

        <div class="privicy">
          <el-checkbox v-model="agreePrivicy" @change="changeAgreePrivicy">我已阅读并接受 <router-link :to="{ name: 'PrivacyPolicy', params: { to: 'peer' } }" target="_blank">用户协议</router-link> 和 <router-link :to="{ name: 'PrivacyPolicy', params: { to: 'privicy' } }" target="_blank">隐私政策</router-link></el-checkbox>
          <span class="agree-error" v-show="showAgreeError">请勾选</span>
        </div>

        <el-form-item class="join-btn">
          <el-button type="primary" @click="formSubmit"
            class="common-button" :loading="submiting">提交信息</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import sensorsdata from 'sa-sdk-javascript';
import validates from '../libs/validates';
import utils from '../libs/utils';
import Http from '../libs/http';
import uploadFileService from '../services/upload-file-service';
import pcdService from '../services/pcd-service';
import { JOIN_FROM_MAP } from '../maps/sensors-maps';

export default {
  data() {
    return {
      pcds: {},
      submitted: false,
      submiting: false,
      agreePrivicy: false,
      showAgreeError: false,
      dataModel: {
        peer_name: '',
        contacts: '',
        mobile_phone: '',
        email: '',
        province_code: '',
        city_code: '',
        county_code: '',
        detail_address: '',
        peer_from: 0,
      },
      rules: {
        peer_name: [
          validates.required('旅行社/门店名称'),
        ],
        contacts: [
          validates.required('申请人姓名'),
        ],
        mobile_phone: [
          validates.required('手机号'),
          validates.mobile('手机号'),
        ],
        email: [
          validates.email('邮箱'),
        ],
        detail_address: [
          validates.required('详细地址'),
        ],
        peer_from: [
          validates.requiredRadio('来源'),
        ],
      },
      upload_file: null,
      commonVisaCountry: {
        1: '申根',
        2: '俄罗斯',
        3: '英国',
        4: '美国',
        5: '加拿大',
        6: '澳大利亚',
        7: '新加坡',
        8: '日本',
        9: '韩国',
        10: '越南',
        11: '菲律宾',
        12: '柬埔寨',
        13: '泰国',
        14: '马来西亚',
        15: '中国台湾',
        16: '其他',
      },
      monthVisaLevel: {
        1: '0-10本',
        2: '10-50本',
        3: '50-100本',
        4: '100本以上',
      },
      selectedCountry: [],
      selectedCountryKey: [],
      showCountryListBox: false,
    };
  },
  computed: {

    // 没有区
    noneCounty() {
      return Boolean(this.dataModel.province_code) && Boolean(this.dataModel.city_code) && !this.pcds[this.dataModel.city_code];
    },

    pcdValid() {
      if (!this.noneCounty) {
        return this.dataModel.province_code && this.dataModel.city_code && this.dataModel.county_code;
      }
      return this.dataModel.province_code && this.dataModel.city_code;
    },
  },
  created() {
    pcdService.getPcd().then(pcds => this.pcds = pcds).catch((e) => {
      if (e) console.log(e);
    });
  },
  methods: {
    isShowCountryListBox(isShow) {
      if (isShow === true) {
        this.showCountryListBox = !this.showCountryListBox;
      } else {
        this.showCountryListBox = false;
      }
    },

    selectCountry(k) {
      if (this.selectedCountry && this.selectedCountry.length >= 3) {
        this.$message({
          message: '最多可选择三个国家，非选择国家仍可正常办理',
          type: 'warning',
        });
        return;
      }
      const isCanAdd = _.find(this.selectedCountry, el => el.id === +k);
      if (isCanAdd) {
        return;
      }
      this.selectedCountryKey.push(k);
      this.selectedCountry.push({
        id: +k,
        name: this.commonVisaCountry[k],
      });
    },

    deleteCountry(event, k) {
      event.stopPropagation();
      event.cancelBubble = true;
      this.selectedCountryKey.splice(+k, 1);
      this.selectedCountry.splice(+k, 1);
    },

    fileInput() {
      this.$el.querySelector('#upload-file').click();
    },
    changeAgreePrivicy() {
      this.showAgreeError = false;
    },
    fileChange(e) {
      const file = e.target.files[0];
      if (file) {
        if (file.type.indexOf('image') < 0) {
          return utils.msg.warning('请选择图片文件');
        }
        if (file.size > 5120000) {
          e.target.value = '';
          return utils.msg.warning('文件大小不能超过5M');
        }
        this.upload_file = file;
        utils.toBase64(file).then((v) => {
          this.$el.querySelector('.upload-img').style.backgroundImage = `url(${v})`;
        }).catch((e) => {
          if (e) console.log(e);
        });
      }
    },
    formSubmit() {
      this.submitted = true;

      this.$refs.dataForm.validate((valid) => {
        if (!this.agreePrivicy) {
          this.showAgreeError = true;
          return false;
        }

        if (valid && this.pcdValid && this.upload_file) {
          // 埋点
          MtaH5.clickStat('submitjoininfo');
          sensorsdata.track('SignUp', {
            sign_up_source: JOIN_FROM_MAP[this.$route.query.from],
            peer_name: this.dataModel.peer_name,
            EventKey: '无',
          });

          this.submiting = true;
          const postData = utils.extend({}, this.dataModel);
          postData.province_code = +postData.province_code;
          postData.city_code = +postData.city_code;
          postData.county_code = Number(postData.county_code) || 0;
          postData.peer_from = Number(postData.peer_from) || 0;
          postData.month_visa_level = postData.month_visa_level ? +postData.month_visa_level : undefined;
          if (this.selectedCountry && this.selectedCountry.length > 0) {
            postData.common_visa_country = this.selectedCountry.map(el => el.id);
          }

          uploadFileService.uploadFile(this.upload_file, false, { noKey: true }).then((res) => {
            postData.card = res;
            Http.post('/sys/peer_book_add', postData).then(() => {
              MtaH5.clickStat('joinsuccessful');
              utils.msg.success('已收到您的信息，我们将尽快联系您，请耐心等待！');
              this.$router.replace({ name: 'index' });
            }, (err) => {
              if (err) console.log(err);
              this.submiting = false;
            });
          }, (e) => {
            if (e) console.log(e);
            utils.promise.reject('');
          });
        }
      });
    },
  },
  directives: {

    // 自定义指令，当点击目标元素及其子代之外的元素时执行指令绑定的函数
    clickOutside: {

      // 初始化指令
      bind(el, binding) {
        function clickHandler(e) {

          // 这里判断点击的元素是否是本身及其子代，如果是，则返回
          if (el.contains(e.target)) {
            return false;
          }

          // 判断指令中是否绑定了函数
          if (binding.expression) {

            // 如果绑定了函数 则调用那个函数，此处 binding.value 就是绑定的函数
            binding.value(e);
          }
        }

        // 给当前元素绑定个私有变量，方便在 unbind 中可以解除事件监听
        el.__vueClickOutside__ = clickHandler;
        document.addEventListener('click', clickHandler);
      },
      unbind(el) {

        // 解除事件监听
        document.removeEventListener('click', el.__vueClickOutside__);
        delete el.__vueClickOutside__;
      },
    },
  },
};
</script>

<style lang="less">
@import  '../assets/less/variable';

.join-wrap>#main{
  padding-bottom:50px;

  .container{
    background-color:white;
    margin-top:40px;
    padding:50px 195px 10px 150px;
  }

  .title{
    font-size:24px;
    color:#333;
    text-align:center;
  }

  .desc{
    font-size:16px;
    color:#aaa;
    text-align:center;
    margin-top:15px;
  }

  .el-form{
    margin-top:40px;
  }

  .el-form-item{
    margin-bottom:36px;
  }

  .privicy {
    a {
      &:hover,
      &:visited,
      &:link,
      &:active {
        color: #599FFF;
      }
    }
    .agree-error {
      margin-left: 5px;
      font-size: 14px;
      line-height: 14px;
      color: #FF6464;
    }
    .el-checkbox__inner {
      margin-top: 2px;
    }
  }

  .el-form-item.is-required .el-form-item__label:after{
    content: '*';
    color: red;
    font-size:18px;
    display:inline-block;
    vertical-align:middle;
  }

  .el-form-item__label{

    font-size:15px;
    color:#333;
  }

  .el-form-item__error{
    font-size:13px;
  }

  .el-input__inner{
    height:40px;
  }

  .pcds .el-select{
    width:120px;
  }

  .join-btn{
    text-align:center;
    margin-top:40px;

    .el-button{
      width:300px;
      height:50px;
      font-size:18px;
    }
  }

  .el-upload{
    width:240px;
    line-height:1;
  }

  .el-dragger{
    width:240px;
    border:none;
    background-color:#e8e8e8;
    border-radius:0;
    border:1px solid @border;
    position: relative;
  }

  .upload-icon{
    margin: 50px 0;
  }

  .upload-img{
    background:#e8e8e8 no-repeat center center;
    background-size:cover;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .upload-reupload{
    position:absolute;
    right:5px;
    bottom:5px;
    padding:8px 12px;
    border-radius:30px;
  }

  .common-visa-country {
    margin-bottom: 36px;
    position: relative;
    .title {
      font-size:16px;
      color: #2F333D;
      text-align: left;
      line-height: 1;
      margin-bottom: 12px;
    }
    .select-box {
      position: relative;
      .input-box {
        input {
          width: 100%;
          outline: none;
          height:40px;
          background:rgba(255,255,255,1);
          border-radius:2px;
          border:1px solid rgba(222,226,230,1);
          font-size:14px;
          color: #91999F;
          padding: 10px;
          cursor: pointer;

          // 设置 input 占位符样式
          &::-webkit-input-placeholder {
            color: #91999F;
          }
          &::-moz-placeholder{
            color: #91999F;
          }
          &:-ms-input-placeholder {
            color: #91999F;
          }
        }
      }
      .icon-arrow {
        cursor: pointer;
        position: absolute;
        top: 15px;
        right: 10px;
        z-index: 1;
        transition: transform .3s;
        &.rotate {
          transform: rotate(180deg);
        }
      }
      .tag-box {
        position: absolute;
        padding: 5px 9px;
        top: 1px;
        left: 1px;
        background: #fff;
        width: 99%; // 避免遮住右边框
        display: flex;
        align-items: center;
        justify-content: flex-start;
        span {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size:14px;
          text-align: center;
          padding: 0 12px;
          line-height:28px;
          color: #2F333D;
          background:rgba(89,159,255,0.08);
          border-radius:2px;
          margin-right: 12px;
          img {
            width: 12px;
            height: 12px;
            margin-left: 10px;
            cursor: pointer;
          }
        }
      }
    }
    .country-list-box {
      height:156px;
      background:rgba(255,255,255,1);
      border-radius:2px;
      border:1px solid rgba(222,226,230,1);
      position: absolute;
      left: 0;
      top: 76px;
      z-index: 10;
      padding: 16px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap: wrap;
      span {
        display: inline-block;
        font-size:14px;
        text-align: center;
        width:76px;
        line-height:28px;
        background:rgba(89,159,255,0.08);
        border-radius:2px;
        margin-right: 12px;
        cursor: pointer;
        &:hover, &.selected {
          color: #599FFF;
        }
      }
    }
  }

  .month-visa-level {
    .el-select {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Join.vue